// Static auth shell assets (served from `public/images`).
export const AUTH_LAYOUT_BACKGROUND_SRC = '/images/auth/scalar-auth-bg.png';
export const AUTH_LAYOUT_MARK_LOGO_SRC = '/images/auth/scalar-auth-logo.svg';
